import { api } from "./useApi";

export const pagarmeApi = () => ({
    verificarAutenticacao: async () => {
        const response = await api.post("pagarme_hub/verificar_autenticacao");
        return response.data;
    },
});
